// Cxs is mandatory here, cannot test branch coverage
/* istanbul ignore next */
export const themeBackgroundColor = (theme = {}, cxs) =>
  theme.paletteSecondary &&
  cxs({
    backgroundColor: `${theme.paletteSecondary} !important`,
  });

// Cxs is mandatory here, cannot test branch coverage
/* istanbul ignore next */
export const themeForegroundColor = (theme = {}, cxs) =>
  theme.paletteSecondary &&
  cxs({
    color: `${theme.paletteSecondary} !important`,
    'border-color': `${theme.paletteSecondary} !important`,
  });

// Cxs is mandatory here, cannot test branch coverage
/* istanbul ignore next */
export const themeFontColor = (theme = {}, cxs) =>
  theme.keyLightBase &&
  cxs({
    color: `${theme.keyLightBase} !important`,
  });

// Cxs is mandatory here, cannot test branch coverage
/* istanbul ignore next */
export const headerBackgroundIcon = (cxs) =>
  cxs &&
  cxs({
    backgroundRepeat: 'no-repeat !important',
    backgroundSize: 'contain !important',
  });

// Cxs is mandatory here, cannot test branch coverage
/* istanbul ignore next */
export const themeHeadingFontColor = (theme = {}, cxs) =>
  theme.keyLightBase &&
  cxs({
    color: `${theme.keyLightBase} !important`,
  });

// Cxs is mandatory here, cannot test branch coverage
/* istanbul ignore next */
export const themePartnerTextColor = (theme = {}, cxs) =>
  theme.fontColor &&
  cxs({
    color: `${theme.fontColor} !important`,
  });

export const themePrimaryColorBigText = (theme = {}, cxs) =>
  theme.primaryColor &&
  cxs({
    color: `${theme.primaryColor} !important`,
    backgroundColor: 'transparent',
  });

// Cxs is mandatory here, cannot test branch coverage
/* istanbul ignore next */
export const headerBackgroundColor = (color, cxs) =>
  color &&
  cxs &&
  cxs({
    backgroundColor: `${color} !important`,
  });

// Cxs is mandatory here, cannot test branch coverage
/* istanbul ignore next */
export const headerBackgroundGradientColor = (color, cxs) =>
  color &&
  cxs &&
  cxs({
    background: `linear-gradient(to left, ${color}CC, ${color}) !important`,
    // IE & Edge: fallback for browsers lacking support for 8 digit hex codes
    backgroundColor: `${color}`,
  });

// Cxs is mandatory here, cannot test branch coverage
/* istanbul ignore next */
export const headerMwebBackgroundGradientColor = (color, cxs) =>
  color &&
  cxs &&
  cxs({
    background: `radial-gradient(circle, ${color}CC, ${color}) !important`,
    // IE & Edge: fallback for browsers lacking support for 8 digit hex codes
    backgroundColor: `${color}`,
  });
